// @flow
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useLocation, useHistory } from 'react-router-dom';
import goalcardActions from 'actions/goalcard';
import ProcessingLoader from 'components/shared/ProcessingLoader/ProcessingLoader';
import ErrorPopUp from 'components/shared/ErrorPopUp/ErrorPopUp';

const ViewGoalcardRedirect = (props: Props) => {
  const { t } = useTranslation();
  const location = useLocation();
  const browserHistory = useHistory();
  const locationParams = new URLSearchParams(location.search);
  const goalcardId = locationParams.get('id');

  const affiliateCode = locationParams.get('code');

  const contactAffiliateCode = locationParams.get('ac');

  const [errorPopUp,
    updateErrorPopUp,
  ]: [any, ((any => any) | any) => void] = useState({ show: false });

  const getGoalcardById = (id) => {
    props.getGoalcard(id)
      .then(() => {
        browserHistory.push('/goalcard');
      })
      .catch((error) => {
        const errorState = { ...errorPopUp, show: true };

        if (error.status === 409) {
          errorState.description = t('goalcard_alreadyclaimed');
        }

        updateErrorPopUp(errorState);
      });
  };

  const getGoalcardByAffiliateCode = (code) => {
    props.getAffiliateGoalcard(code)
      .then(() => {
        browserHistory.push(`/goalcard/${code}`);
      })
      .catch((error) => {
        const errorState = {
          ...errorPopUp,
          show: true,
        };

        if (error.status === 404) {
          errorState.description = t('goalcard_affiliate_program_not_found');
        }

        updateErrorPopUp(errorState);
      });
  };

  const getGoalcardByContactCode = (contactCode) => {
    props.getContactAffiliateGoalcard(contactCode)
      .then(() => {
        browserHistory.push(`/goalcard/${contactCode}`);
      })
      .catch((error) => {
        const errorState = {
          ...errorPopUp,
          show: true,
        };

        if (error.status === 404) {
          errorState.description = t('goalcard_affiliate_program_not_found');
        } else if (error.status === 409) {
          errorState.description = t('goalcard_affiliate_contact_not_found');
        }

        updateErrorPopUp(errorState);
      });
  };

  const fetchGoalcard = () => {
    if (goalcardId) {
      getGoalcardById(goalcardId);
    } else if (affiliateCode) {
      getGoalcardByAffiliateCode(affiliateCode);
    } else if (contactAffiliateCode) {
      getGoalcardByContactCode(contactAffiliateCode);
    }
  };

  useEffect(() => {
    fetchGoalcard();
  }, []);

  return (
    <>
      <ProcessingLoader show={props.isProcessing} />

      <ErrorPopUp
        description={errorPopUp.description}
        title={t('ops_title')}
        show={errorPopUp.show}
        btnBackText={t('retry_title')}
        onBack={() => {
          updateErrorPopUp({ ...errorPopUp, show: false });
          fetchGoalcard();
        }}
      />
    </>
  );
};

// Map Props
const mapStateToProps = (state) => ({
  isProcessing: state.viewGoalcard.isProcessing,
});

// Map Dispatch
const mapDispatchToProps = (dispatch) => ({
  getGoalcard:
    (goalcardId: string) => dispatch(goalcardActions.getGoalcard(goalcardId)),
  getAffiliateGoalcard:
  (affiliateCode: string) => dispatch(goalcardActions.getAffiliateGoalcard(affiliateCode)),
  getContactAffiliateGoalcard:
  (contactAffiliateCode: string) => dispatch(goalcardActions.getContactAffiliateGoalcard(contactAffiliateCode)),
});

// Container Component
const ViewGoalcardPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ViewGoalcardRedirect);

export default ViewGoalcardPage;
